// Self-contained data for the Abo & Penaranda Law Firm concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/05_Abo_and_Penaranda_Law_Firm
// (research snapshot 2026-08-21). This is a modernization/credibility-cleanup concept: the firm's
// real live site has placeholder template content and a fake example attorney profile — this
// concept is built to show what the site should look like, using only verified people and facts.
// A serious 1-star refund allegation exists in the dossier's review evidence and is deliberately
// NOT surfaced here (internal due-diligence only, per MySiteCare policy) — but no "100% satisfied"
// or similarly overstated claim is made either. Self-presented awards/badges are not used here;
// Mackrell International membership is used since it is an independently checkable affiliation.
export const SLUG = "abo-penaranda-law-bgc-concept";

export const BIZ = {
  name: "Abo & Penaranda Law Firm",
  fullName: "Abo and Penaranda Law Firm",
  address: "1701 One Park Drive, 11th Drive corner 9th Avenue, Bonifacio Global City, Taguig 1630",
  phone: "+63273418944",
  phoneDisplay: "+63 2 7341 8944",
  mobile: "+63 917 167 8387",
  email: "abopenaranda@abolawfirm.ph",
  website: "https://abolawfirm.ph/",
  facebook: "https://www.facebook.com/abolawbgc",
  instagram: "https://www.instagram.com/abolawfirm/",
  linkedin: "https://www.linkedin.com/company/abo-and-penaranda-law/",
  mapEmbed: "https://www.google.com/maps?q=One+Park+Drive+9th+Avenue+BGC+Taguig&output=embed",
};

export const NAV_PAGES = [
  { key: "home", label: "Home", path: "" },
  { key: "about", label: "About", path: "/about" },
  { key: "team", label: "Our Team", path: "/team" },
  { key: "practice-areas", label: "Practice Areas", path: "/practice-areas" },
  { key: "contact", label: "Contact", path: "/contact" },
];

export const TEAM = [
  { name: "Atty. Marvi R. Abo", role: "Founder & CEO", photo: "/law/abo-penaranda-law-bgc-concept/atty-abo.png" },
  { name: "Atty. Jon Dominic Penaranda", role: "Senior Partner" },
  { name: "Atty. Danilo R. Rico III", role: "Senior Partner" },
  { name: "Atty. Nick Pataueg Jr.", role: "Of Counsel" },
  { name: "Atty. Victoria Marie Balilo", role: "Senior Counsel", photo: "/law/abo-penaranda-law-bgc-concept/atty-balilo.png" },
  { name: "Atty. Rexford Resurreccion", role: "Mid-Level Counsel", photo: "/law/abo-penaranda-law-bgc-concept/atty-resurreccion.jpg" },
];

export const ABOUT = {
  founded: "We were founded in 2018",
  size: "We're a privately held firm with roughly 11–50 employees.",
  affiliation: "We're a Philippines member of Mackrell International, a global network spanning 60 countries and roughly 4,500 lawyers.",
  positioning: "Our approach emphasizes trust and peace of mind in the lawyer-client relationship, built on resourcefulness — the idea that careful, resourceful work can compensate for limited resources — and an ambition to become a great firm, not merely a large one.",
};

export const PRACTICE_GROUPS = [
  {
    title: "Litigation & Disputes",
    areas: ["Civil Litigation", "Criminal Litigation", "Arbitration & Mediation"],
  },
  {
    title: "Family & Estate",
    areas: ["Family Law", "Annulment, Nullity & Adoption", "Wills, Succession, Probate & Trusts", "Estate Planning"],
  },
  {
    title: "Corporate & Regulatory",
    areas: ["Corporate Law & Business Registration", "Taxation", "Administrative Law", "FinTech, E-Wallet, EMI & VASP Regulatory", "CEZA / PEZA Regulatory", "Energy & Mining"],
  },
  {
    title: "Property & Immigration",
    areas: ["Real Estate", "Naturalization & Immigration"],
  },
  {
    title: "Notarial & Consultations",
    areas: ["Notarial Services", "Online Legal Consultations"],
  },
];

export const REVIEW = {
  quote: "Used the firm for a tenant-eviction matter. The tenant was removed at the earliest opportunity — specifically thanks Atty. Marvi Abo and strongly recommends the firm.",
  author: "Edmond Mangulabnan",
  date: "November 2019",
  source: "BusinessList",
  sourceUrl: "https://www.businesslist.ph/review/5206",
};

export const REPUTATION_NOTE = "Current public listings show approximately 4.8★ across roughly 18 reviews. Reputation evidence is mixed across sources — reach out directly to discuss your matter.";
